import { format } from "date-fns"

export function formatReferralDate(date: Date) {
  return format(date, "dd/MM/yyyy")
}
